import { z } from "zod";

const texto = (limite: number) => z.string().trim().max(limite, `Máximo de ${limite} caracteres.`).nullable();
const data = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida.').nullable();

export const ObraChecklistServicoLiberacaoSchema = z.object({
  status: z.coerce.number().int().min(0).max(2).default(0),
  dataLiberacao: z.coerce.date().nullable().default(null),
  idFuncionarioResponsavel: z.coerce.number().int().positive().nullable().default(null),
  itens: z.array(z.object({
    idChecklistServicoLiberacao: z.number().int().positive(),
    inspecao1: texto(10),
    inspecao2: texto(10),
  })).min(1, 'Nenhum item de liberação cadastrado para este checklist.'),
});

export type ObraChecklistServicoLiberacaoForm = z.infer<typeof ObraChecklistServicoLiberacaoSchema>;

export const defaultObraChecklistServicoLiberacaoForm: ObraChecklistServicoLiberacaoForm = {
  status: 0,
  dataLiberacao: null,
  idFuncionarioResponsavel: null,
  itens: [],
};

export const ObraChecklistServicoLiberacaoItemSchema = z.object({
  idChecklistServicoLiberacao: z.number().int().positive(),
  descricao: texto(500),
  inspecao1: texto(10),
  dataInspecao1: data,
  idFuncionarioResponsavelInspecao1: z.number().int().positive().nullable(),
  inspecao2: texto(10),
  dataInspecao2: data,
  idFuncionarioResponsavelInspecao2: z.number().int().positive().nullable(),
})

export type ObraChecklistServicoLiberacaoItemForm = z.infer<typeof ObraChecklistServicoLiberacaoItemSchema>;
